import { get } from '../..';

const getAreas = (parentLocationId: string) => get(`locations/areas?ParentId=${parentLocationId}`);

export default getAreas;
